var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiceRect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.45C0 8.26038 7.34256 0 16.4 0H63.6C72.6572 0 80 8.26038 80 18.45C80 28.6396 72.6572 36.9 63.6 36.9H60.0139C49.2232 36.9 40.3809 46.5359 40.0377 58.6692L40 60L39.9498 58.5219C39.5399 46.4493 30.7213 36.9 19.9822 36.9H16.4C7.34256 36.9 0 28.6396 0 18.45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceRect);
export default __webpack_public_path__ + "static/media/dice_rect.a790966240a13ad676e9731b1fec45f8.svg";
export { ForwardRef as ReactComponent };